<template>
  <el-dialog
    title="匹配结果详情"
    :visible.sync="visible"
    width="1200px"
    :before-close="closeModal"
    custom-class="match-result-dialog"
  >
    <div class="modal-body">
      <div class="order-info">
        订单信息：
        <span>时间：{{ order.showTime }}</span>
        <span>人数：{{ order.number }}</span>
        <span>出发地：{{ order.departure }}</span>
        <span>目的地：{{ order.destination }}</span>
      </div>

      <div v-if="matchData && matchData.length > 0" class="match-info">
        <el-table
          :data="matchData"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          border
          stripe
        >
          <el-table-column
            prop="driverNo"
            label="司机编号"
            width="100"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="leftSeats"
            label="剩余座位"
            width="80"
            align="center"
          ></el-table-column>

          <el-table-column prop="ok" label="是否匹配" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.needShunt ? 'warning' : scope.row.ok ? 'success' : 'danger'"
                ><span v-if="scope.row.needShunt">
                  <span v-if="!scope.row.isDepPointOk && !scope.row.isDestPointOk"
                    >起点/终点分流</span
                  >
                  <span v-else-if="!scope.row.isDepPointOk">起点分流</span>
                  <span v-else-if="!scope.row.isDestPointOk">终点分流</span>
                </span>
                <span v-else-if="scope.row.ok">完全匹配</span>
                <span v-else>不匹配</span>
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="onGoingRoute" label="进行中" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.onGoingRoute ? 'danger' : 'success'">{{
                scope.row.onGoingRoute ? "开始行程" : "未出发"
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="时间状态">
            <template slot-scope="scope">
              <div class="status-info">
                <div
                  class="status-item"
                  :class="{ 'status-ok': scope.row.isTimeOk, 'status-error': !scope.row.isTimeOk }"
                >
                  <span class="status-label">时间匹配:</span>
                  <span class="status-value">{{ scope.row.isTimeOk ? "匹配" : "不匹配" }}</span>
                </div>

                <div class="time-item">
                  <span class="time-label">行程开始时间:</span>
                  <span class="time-value">{{ scope.row.routeTime | dateFormat("hh:mm") }}</span>
                </div>
                <div class="time-item">
                  <span class="time-label">预计上车时间:</span>
                  <span class="time-value" v-if="scope.row.ok && !scope.row.depNeedShunt">{{
                    scope.row.getupTime | dateFormat("hh:mm")
                  }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="地点状态">
            <template slot-scope="scope">
              <div>
                <div class="status-info">
                  <div
                    class="status-item"
                    :class="{
                      'status-ok': scope.row.isDepPointOk,
                      'status-error': !scope.row.isDepPointOk
                    }"
                  >
                    <span class="status-label">上车点:</span>
                    <span class="status-value">{{
                      scope.row.isDepPointOk ? "匹配" : "不匹配"
                    }}</span>
                  </div>
                  <div
                    class="status-item"
                    :class="{
                      'status-ok': scope.row.isDestPointOk,
                      'status-error': !scope.row.isDestPointOk
                    }"
                  >
                    <span class="status-label">下车点:</span>
                    <span class="status-value">{{
                      scope.row.isDestPointOk ? "匹配" : "不匹配"
                    }}</span>
                  </div>
                </div>

                <div class="score-info">
                  <div class="score-item">
                    <span class="score-label">上车点不顺路指数:</span>
                    <span class="score-value">{{ scope.row.depNotOnwayScore }}</span>
                  </div>
                  <div class="score-item">
                    <span class="score-label">下车点不顺路指数:</span>
                    <span class="score-value">{{ scope.row.destNotOnwayScore }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click.stop="showCurrentRoutePlan(scope.row)">
                当前规划
              </el-button>
              <el-button size="mini" type="text" @click.stop="showTestRoutePlan(scope.row)">
                模拟派单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-else class="no-data">
        <p>暂无匹配数据</p>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeModal">取消</el-button>
      <el-button size="small" type="primary" @click="closeModal">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { SHOW_TEST_ROUTE_PLAN, SHOW_ROUTE_PLAN, ORDER_CHANGE } from "@/core/const/global-event";
import { matchRoute } from "@/api";
import { SessionStorage } from "@/util";
import { ROUTE_PLAN_MAP } from "@/core/const/global-const";

export default {
  name: "MatchResult",
  data() {
    return {
      visible: false,
      matchData: null,
      order: {}
    };
  },
  methods: {
    show(order) {
      this.order = order;
      SessionStorage.clear(ROUTE_PLAN_MAP);
      matchRoute(order.id).then((res) => {
        this.matchData = res.data;
        this.visible = true;
      });
    },
    closeModal() {
      this.visible = false;
      this.matchData = null;
    },

    async showTestRoutePlan(data) {
      const { routeId, orderId } = data;
      this.$bus.$emit(SHOW_TEST_ROUTE_PLAN, routeId, [orderId], false, (planFinished) => {
        if (planFinished) {
          this.closeModal();
          this.$bus.$emit(ORDER_CHANGE);
        }
      });
    },

    async showCurrentRoutePlan(data) {
      const { routeId } = data;
      this.$bus.$emit(SHOW_ROUTE_PLAN, { id: routeId }, false, this.order);
    }
  }
};
</script>

<style scoped>
.match-result-dialog {
  border-radius: 8px;
}

.modal-body {
  padding: 0;
}

.time-info,
.status-info,
.score-info,
.other-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.time-item,
.status-item,
.score-item,
.other-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.time-label,
.status-label,
.score-label,
.other-label {
  color: #666;
  font-size: 12px;
}

.time-value,
.status-value,
.score-value,
.other-value {
  color: #333;
  font-weight: 500;
  font-size: 12px;
}

.status-ok .status-value {
  color: #67c23a;
}

.status-error .status-value {
  color: #f56c6c;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
}

.dialog-footer {
  text-align: right;
}

/* 表格样式优化 */
.el-table {
  font-size: 13px;
}

.el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}

.el-table td {
  padding: 8px 0;
}

/* 响应式处理 */
@media (max-width: 1200px) {
  .el-table {
    font-size: 12px;
  }

  .time-item,
  .status-item,
  .score-item,
  .other-item {
    font-size: 11px;
  }
}

.order-info {
  span {
    margin-right: 20px;
  }
  margin-bottom: 10px;
}
</style>
